import { forwardRef, type HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

interface CardProps extends HTMLAttributes<HTMLDivElement> {}

const Card = forwardRef<HTMLDivElement, CardProps>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('rounded-2xl bg-white shadow-sm', className)} {...props} />
))
Card.displayName = 'Card'

export { Card }
export type { CardProps }
